(() => {
  const filterButton = document.querySelector('[data-collection-toolbar-filter]');
  const sortButton = document.querySelector('[data-collection-toolbar-sort]');
  const filterDrawer = document.querySelector('[data-collection-filter-drawer]');
  const sortSheet = document.querySelector('[data-collection-sort-sheet]');
  const sectionRoot = (filterDrawer || sortSheet)?.closest('.shopify-section');

  if (!filterDrawer && !sortSheet) return;

  const remoteFilterUrl = filterDrawer?.dataset.collectionFilterRemoteUrl;
  if (remoteFilterUrl) {
    fetch(remoteFilterUrl, { headers: { Accept: 'text/html' } })
      .then((res) => (res.ok ? res.text() : Promise.reject(res.status)))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const remoteList = doc.querySelector('[data-collection-filter-list]');
        const localList = filterDrawer.querySelector('[data-collection-filter-list]');
        if (remoteList && localList) {
          localList.replaceWith(remoteList);
        }
      })
      .catch(() => {});
  }

  const updateSectionStacking = (isActive) => {
    if (!sectionRoot) return;
    sectionRoot.classList.toggle('collection-toolbar-section--active', isActive);
  };

  const updateBodyLock = () => {
    const isLocked =
      (filterDrawer && filterDrawer.classList.contains('is-open')) ||
      (sortSheet && sortSheet.classList.contains('is-open'));

    document.body.classList.toggle('collection-toolbar--locked', isLocked);
    updateSectionStacking(isLocked);
  };

  const closeFilter = () => {
    if (!filterDrawer) return;
    filterDrawer.classList.remove('is-open');
    updateBodyLock();
  };

  const closeSort = () => {
    if (!sortSheet) return;
    sortSheet.classList.remove('is-open');
    updateBodyLock();
  };

  const openFilter = () => {
    closeSort();
    if (!filterDrawer) return;
    filterDrawer.classList.add('is-open');
    updateBodyLock();
  };

  const openSort = () => {
    closeFilter();
    if (!sortSheet) return;
    sortSheet.classList.add('is-open');
    updateBodyLock();
  };

  if (filterButton) {
    filterButton.addEventListener('click', openFilter);
  }

  if (sortButton) {
    sortButton.addEventListener('click', openSort);
  }

  document.querySelectorAll('[data-collection-filter-close]').forEach((element) => {
    element.addEventListener('click', closeFilter);
  });

  document.querySelectorAll('[data-collection-filter-apply]').forEach((element) => {
    element.addEventListener('click', closeFilter);
  });

  document.querySelectorAll('[data-collection-sort-close]').forEach((element) => {
    element.addEventListener('click', closeSort);
  });

  if (sortSheet) {
    const sortOptions = Array.from(sortSheet.querySelectorAll('[data-collection-sort-option]'));
    const defaultSortValue = sortSheet.dataset.defaultSortValue || 'manual';
    const sortTargetUrl = sortSheet.dataset.sortTargetUrl || '';

    const applySort = (sortValue) => {
      if (!sortValue) return;
      const baseHref = sortTargetUrl
        ? new URL(sortTargetUrl, window.location.origin).toString()
        : window.location.href;
      const url = new URL(baseHref);
      const params = url.searchParams;

      if (sortValue === defaultSortValue) {
        params.delete('sort_by');
      } else {
        params.set('sort_by', sortValue);
      }

      params.delete('page');
      url.search = params.toString();
      window.location.assign(url.toString());
    };

    sortOptions.forEach((option) => {
      option.addEventListener('click', () => {
        sortOptions.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });

        option.classList.add('is-selected');
        option.setAttribute('aria-pressed', 'true');
        closeSort();
        applySort(option.dataset.sortValue);
      });
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeFilter();
    closeSort();
  });
})();
